import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import ImageCropper from "gallery/image/ImageCropper";

class ImageItemModal extends Modal {
    constructor(item, settings = {okayText: null, title: null}) {
        super({class: "admin-modal--image admin-modal--navigation "});
        this.item = item;

        this.data = $.extend(true, {}, item.data);
        this.imageChanged = false;

        this.setContent(
            eotwJSXFactory('form', {class: "admin-form"}, [
                eotwJSXFactory('div', {class: "admin-modal__navigation"}, [
                    eotwJSXFactory('button', {class: "admin-modal__link admin-modal__link--active", type: "button"}, ["Edit Photo"])
                ]),
                eotwJSXFactory('h2', null, [settings.title ? settings.title : "Photo Details"]),
                eotwJSXFactory('p', null, ["Use the controls below to modify your photo if required, as well as setting appropriate text for the image."]),
                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--half"}, [
                    eotwJSXFactory('div', {class: "admin-form__row admin-modal__image admin-modal__image--preview-wrap"}, [
                        eotwJSXFactory('canvas', {class: "admin-modal__image admin-modal__image--preview js-canvas"})
                    ]),

                    this.item.gallery.data.profile.showImageThumb ?
                        eotwJSXFactory('div', {class: "admin-form__row admin-modal__image admin-modal__image--preview-wrap"}, [
                            eotwJSXFactory('div', {class: "js-thumb-wrap admin-modal__image admin-modal__image--thumbnail"})
                        ]) : []

                ]),
                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--half"}, [
                    this.item.gallery.data.profile.showTitle ?
                        eotwJSXFactory('div', {class: "admin-form__row admin-form__row--image"}, [
                            eotwJSXFactory('label', {class: "admin-form__label", for: "image-title"}, ["Title"]),
                            eotwJSXFactory('input', {type: "text", class: "admin-form__input admin-form__input--gallery", id: "image-title", name: "title", value: this.data.title}),
                            eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                        ]) : [],

                    this.item.gallery.data.profile.showAltTitle ?
                        eotwJSXFactory('div', {class: "admin-form__row admin-form__row--image"}, [
                            eotwJSXFactory('label', {class: "admin-form__label", for: "image-alt-title"}, ["Alt Text"]),
                            eotwJSXFactory('input', {type: "text", class: "admin-form__input admin-form__input--gallery", id: "image-alt-title", name: "altTitle", value: this.data.altTitle}),
                            eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                        ]) : [],


                    this.item.gallery.data.profile.showDescriptions ?
                        eotwJSXFactory('div', {class: "admin-form__row admin-form__row--image"}, [
                            eotwJSXFactory('label', {class: "admin-form__label", for: "image-description"}, ["Description"]),
                            eotwJSXFactory('textarea', {type: "text", class: "admin-form__input admin-form__input--textarea admin-form__input--gallery", id: "image-description", name: "description"}, [this.data.description]),
                            eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                        ]) : []

                ]),

                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, [settings.okayText ? settings.okayText : "Ok"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel", type: "button"}, ["Cancel"])
                ])
            ])
        );


        let currentCrop = null;
        if ("undefined" !== typeof this.data.customData.cropX && "undefined" !== typeof this.data.customData.cropY && "undefined" !== typeof this.data.customData.cropSize) {
            currentCrop = {
                x: parseInt(this.data.customData.cropX),
                y: parseInt(this.data.customData.cropY),
                size: parseInt(this.data.customData.cropSize),
            }
        }

        this.imageCropper = new ImageCropper(this.$content.find(".js-canvas"), this.item.getImageUrl('1' /*Original*/), currentCrop, this.item.gallery.data.profile.showImageThumb);
        if (this.item.gallery.data.profile.showImageThumb) {
            this.$content.find(".js-thumb-wrap").append(this.imageCropper.$thumbWrap);
        }

        this.bindEvents();
    }


    bindEvents() {
        this.on("click", ".js-cancel", () => this.emit("cancel") && this.destroy() && false);

        FormValidator.attach(this.$content).on("submit", ($form) => {

            $.extend(this.item.data, this.data, $form.serializeJSON());

            this.item.changed = true;
            let fullDataUrl;

            if (this.imageChanged) {
                this.item.imageChanged = true;
                this.item.image = this.imageCropper.getImageBlob();
                fullDataUrl = this.imageCropper.getImageDataUrl();
            }
            let thumbDataUrl;
            if (this.item.gallery.data.profile.showImageThumb) {
                thumbDataUrl = this.imageCropper.getThumbDataUrl();
            }
            if (this.imageChanged || this.item.gallery.data.profile.showImageThumb) {
                $.each(this.item.data.versions, (type, version) => {
                    if (version.size.mode.id === '2' /*Thumbnail*/) {
                        if (this.item.gallery.data.profile.showImageThumb) {
                            version.url = thumbDataUrl;
                        }
                    } else {
                        if (this.imageChanged) {
                            version.url = fullDataUrl;
                        }
                    }
                });
            }


            this.emit("okay");
            this.destroy();
        });

        this.imageCropper.on("crop", (crop) => {
            this.data.customData.cropX = crop.x;
            this.data.customData.cropY = crop.y;
            this.data.customData.cropSize = crop.size;

        }).on("rotate", () => {
            this.imageChanged = true;
        }).on("cropStart", () => {
            this.$content.find(".admin-btn[type='submit']").attr("disabled", true).addClass("admin-btn--disabled")
        }).on("cropEnd", () => {
            this.$content.find(".admin-btn[type='submit']").attr("disabled", false).removeClass("admin-btn--disabled")
        });
    }

    destroy() {
        super.destroy();

        this.imageCropper.destroy();
    }

}


export default ImageItemModal;
